var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7619 2.52286C17.5762 2.01822 18.1854 1.22361 18.4759 0.287391C17.7108 0.758029 16.8737 1.08956 16.0008 1.26765C14.7905 -0.0595809 12.873 -0.382568 11.3197 0.479163C9.7664 1.34089 8.96183 3.174 9.35558 4.9542C6.22156 4.79108 3.30167 3.25633 1.3225 0.731849C0.289605 2.57882 0.817435 4.93987 2.52873 6.12749C1.90991 6.10687 1.30481 5.93317 0.763888 5.62089C0.763888 5.63784 0.763888 5.65478 0.763888 5.67173C0.764246 7.59567 2.07219 9.2529 3.89119 9.63419C3.3172 9.79608 2.71512 9.81992 2.13089 9.70387C2.64245 11.3492 4.10515 12.4764 5.7723 12.51C4.39152 13.6335 2.6863 14.2428 0.931016 14.2398C0.619894 14.2403 0.309016 14.2217 0 14.1842C1.78246 15.3717 3.85701 16.002 5.97576 15.9997C8.92345 16.0207 11.7563 14.816 13.8406 12.655C15.9249 10.494 17.0867 7.55715 17.0662 4.50127C17.0662 4.32612 17.0623 4.15191 17.0544 3.97865C17.8178 3.4067 18.4766 2.69815 19 1.88631C18.2888 2.21312 17.5344 2.42768 16.7619 2.52286Z",
    fill: "#747683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fcad6565470c17e5610d7e46ecad98b3.svg";
export { ForwardRef as ReactComponent };